module.exports = __webpack_public_path__ + "static/media/goods.fdad0750.svg";